import React, { useEffect } from 'react';
import ChatShell from './chat/ChatShell';
import { markLoginLatency } from '../lib/loginLatency';

export default function Chat() {
  useEffect(() => {
    markLoginLatency('route_transition_complete');
  }, []);
  return <ChatShell />;
}
